import "./_styles.scss";
import React, { useEffect, useState } from "react";
import { Scrollable } from "../../../../components";
import { Checkbox } from "../../../../components/fields";
import { Button, ButtonBase, InputBase, Pagination } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose, faSearch } from "@fortawesome/free-solid-svg-icons";
import TextField from "@mui/material/TextField";

interface EditItemProps {
  data?: any;
}

export default function EditItem({ data }: EditItemProps) {
  const { memberships, status, name } = data;
  const members: string[] = data.members;

  const [searchMember, setSearchMember] = useState<string>("");
  const [selectedMembers, setSelectedMembers] = useState<string[]>([]);
  const [selectedMemberships, setSelectedMemberships] = useState<string[]>([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageCount] = useState(10);
  const [nameTitle, setTitle] = useState("");
  const [message, setMessage] = useState("");

  const handleChange = (item: string, selected: boolean) => {
    let items: string[] = Array.from(selectedMembers);

    if (selected && !items.includes(item)) items.push(item);

    if (!selected && items.includes(item))
      items.splice(selectedMembers.indexOf(item), 1);
    setSelectedMembers(items);
  };

  const handleMembershipdsChange = (item: string, selected: boolean) => {
    let items: string[] = Array.from(selectedMemberships);

    if (selected && !items.includes(item)) items.push(item);

    if (!selected && items.includes(item))
      items.splice(selectedMemberships.indexOf(item), 1);
    setSelectedMemberships(items);
  };

  const changeTitle = (event: any) => {
    setTitle(event.target.value);
  };

  const changeMessage = (event: any) => {
    setMessage(event.target.value);
  };

  const handleSearch = (search: string) => {
    setSearchMember(search);
  };

  const handleClearSearch = () => {
    setSearchMember("");
  };

  const setPage = (_: any, p: number) => {
    setPageNumber(p);
  };

  const setMemberName = () => {
    let member = message;
    setMessage(member + "{member}");
  };

  const setAmountDue = () => {
    let member = message;
    setMessage(member + "{amount}");
  };

  useEffect(() => {
    setTitle(name ?? "");
  }, [name]);

  return (
    <div className="order-item">
      <div className="orderinner">
        <TextField
          id="standard-basic"
          key="titleEntry"
          label="Title"
          variant="standard"
          value={nameTitle}
          onChange={changeTitle}
          error={nameTitle === ""}
          style={{ paddingBottom: "10px", width: "50%" }}
        />
        <div
          style={{
            display: "flex",
          }}
        >
          <h1
            style={{
              paddingRight: "4px",
            }}
          >
            Status:
          </h1>
          <h1 className="heading">{status ? status : "Unkown"}</h1>
        </div>
      </div>
      <div style={{ width: "100%" }}>
        <div
          className="filterContainer"
          style={{
            marginRight: "10px",
          }}
        >
          <h1
            className="heading content"
            style={{ marginBottom: "4px", marginLeft: "4px", marginTop: "4px" }}
          >
            Member Filters
          </h1>
          <InputBase
            key="searchEditEntry"
            className="h-app-search-box-members"
            placeholder="Search"
            value={searchMember}
            onChange={(e: any) => {
              handleSearch(e.target.value);
            }}
            startAdornment={<FontAwesomeIcon icon={faSearch} />}
            endAdornment={
              searchMember ? (
                <ButtonBase
                  key="searchClose"
                  className="close-search"
                  onClick={handleClearSearch}
                >
                  <FontAwesomeIcon icon={faClose} />
                </ButtonBase>
              ) : null
            }
          />
          <div className="liststyle" style={{ height: "22vh" }}>
            <Scrollable key="memberScroll">
              <div className="h-app-library-items">
                {!members || members.length < 1 ? (
                  <span className="loading content">No Members.</span>
                ) : (
                  members.map((d: any) => {
                    return (
                      <div
                        style={{
                          display: "block",
                          paddingLeft: "10px",
                          height: "2px !important",
                        }}
                      >
                        <Checkbox
                          key={d}
                          className="h-app-input-field-members"
                          label={d}
                          onChange={(e: any) =>
                            handleChange(d, e.target.checked)
                          }
                          labelPlacement="start"
                          value={selectedMembers.includes(d)}
                        />
                      </div>
                    );
                  })
                )}
              </div>
            </Scrollable>
            <Pagination
              style={{ width: "100%" }}
              className="pager"
              shape="rounded"
              size="small"
              page={pageNumber}
              count={pageCount}
              color="primary"
              siblingCount={0}
              boundaryCount={1}
              showFirstButton
              showLastButton
              onChange={setPage}
            />
          </div>
        </div>

        <div className="filterContainer">
          <h1 className="heading content">Membership Filters</h1>
          <div
            style={{
              display: "inline",
            }}
          ></div>
          <div className="liststyle">
            <Scrollable className="items" key="membershipScroll">
              <div
                className="h-app-library-items"
                style={{ height: "90% !important" }}
              >
                {!memberships || memberships.length < 1 ? (
                  <span className="loading content">No Memberships Found.</span>
                ) : (
                  memberships.map((d: any) => {
                    return (
                      <div
                        style={{
                          display: "block",
                          paddingLeft: "10px",
                          height: "2px !important",
                        }}
                      >
                        <Checkbox
                          key={"membership-inner-" + d}
                          className="h-app-input-field-members"
                          label={d}
                          onChange={(e: any) =>
                            handleMembershipdsChange(d, e.target.checked)
                          }
                          labelPlacement="start"
                          value={selectedMemberships.includes(d)}
                        />
                      </div>
                    );
                  })
                )}
              </div>
            </Scrollable>
          </div>
        </div>
        <h3> Message Detail</h3>
        <div style={{ display: "inline-block", width: "100%" }}>
          <TextField
            key="messageField"
            label="Message Field"
            multiline={true}
            rows={10}
            style={{ width: "73%" }}
            onChange={changeMessage}
            error={message === ""}
            value={message}
          />
          <div
            style={{ display: "inline-block", height: "240px", width: "25%" }}
          >
            <h3
              style={{
                marginTop: "0px",
                marginLeft: "4px",
                marginBottom: "2px",
              }}
            >
              Properties
            </h3>
            <div
              style={{
                backgroundColor: "#f5f5f5",
                height: "100%",
                width: "100%",
                marginLeft: "2%",
              }}
            >
              <Button
                key="memberNameProperty"
                variant="contained"
                className="propertyButton"
                onClick={setMemberName}
              >
                Member Name
              </Button>
              <Button
                key="memberDueProperty"
                className="propertyButton"
                variant="contained"
                onClick={setAmountDue}
              >
                Amount Due
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
